export const formatarNCM = (ncm) => {
  if (!ncm) {
    return 'N/I';
  }

  ncm = ncm.toString();

  return ncm.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1.$2.$3');
};

const mascaraNCM = {
  install(Vue) {
    Vue.filter('formatarNCM', formatarNCM);
  },
};

export default mascaraNCM;
